import {createContext, useReducer} from "react";

export const ReligionContext = createContext();

export const religionReducer = (state,action) => {
    switch(action.type){
        case 'SET_RELIGIONS':
            return {
                religions: action.payload
            }
        
        case 'CREATE_RELIGION':
            return {
                religions: [action.payload.religion,...state.religions]
            }

        case 'DELETE_RELIGION':
            return {
                religions: state.religions.filter((religion) => religion._id !== action.payload._id)
            }

        default:
            return state
    }
}

export const ReligionContextProvidor = ({children}) =>{
    const [state,dispatch] = useReducer(religionReducer,{
        religions: null,
    });

    return (
        <ReligionContext.Provider value={{...state,dispatch}}>
            {children}
        </ReligionContext.Provider>
    )
}